namespace Customer
{
	export class List
		extends ui.tab.TabHTMLPresentation
	{
		private m_Company:	Wollmilch.CompanyObject;
		private	m_List:			SPA.gui.Listing<Wollmilch.CustomerObject>;

		constructor( company: Wollmilch.CompanyObject )
		{
			super();

			this.m_Company	= company;

			this.m_List		= new SPA.gui.Listing<Wollmilch.CustomerObject>(
				new Customer.data.CustomerCardDataModel(
					this.m_Company,
					{
						number: 5,
						style:
						{
							hover: true
						}
					}
				),
				15,
				( list: SPA.gui.Listing<Wollmilch.CustomerObject>, count: number, page: number ) =>
				{
					count = clamp( count, 5, 50 );

					new Wollmilch.AJAX(
						{
							url: 'customer/list/' + company.ID + '/limit/' + count + '/page/' + page,
							on:
							{
								success( text: string ): void
								{
									let obj: Wollmilch.ResponseObject|null;

									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
											{
												title: [ ui.h( 3, app.getMessage( 'Customer.MSG.error_title' ) ) ],
												body: [ ui.text( app.getMessage( 'Customer.MSG.error_body' ) ) ],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									if ( !obj || !obj.success )
									{
										app.addNotify(
											{
												title: [ ui.h( 3, app.getMessage( 'Customer.MSG.error_title' ) ) ],
												body: [ ui.text( app.getMessage( 'Customer.MSG.error_body' ) ) ],
												context: 'info',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									list.Content().Data( obj.data );
									list.Content().rebuild();

									list.SetPage( page, obj.count );
								}
							}
						}
					).send();
				}
			);
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): List
		{
			super.rebuild( root );

			this.empty();

			this.m_List.rebuild( new ui.Box.Box().appendTo( this ) );

			return this;
		}
	}
}
